import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { VatRateDto } from '../models/vatRate/vatRateDto.model';
import { VatRateTypeDto } from '../models/vatRate/vatRateTypeDto.model';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})
export class VatRateService {

    constructor(private http: HttpClient, private configService: AppConfigService) { }

    getListVatRate(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', 'idVatRate')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/vat-rate/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getListTypeVatRate(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', 1)
            .set('sizePage', 100)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/vat-rate/type/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getVatRateById(idVatRate: number | null): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/filter/${idVatRate}`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return new VatRateDto(response);
            })
        );
    }

    getTypeVatRateById(idVatRate: number, startDate?: string): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/filter/${idVatRate}/'1900-01-01`;
        return this.http.get<any>(url).pipe(
            map(response => {
                return new VatRateTypeDto(response);
            })
        );
    }

    insertVatRate(vatRate: VatRateDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/insert`;
        return this.http.post<any>(url, vatRate).pipe(
            map(response => {
                return new VatRateDto(response);
            })
        );
    }

    insertTypeVatRate(vatRate: VatRateTypeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/type/insert`;
        return this.http.post<any>(url, vatRate).pipe(
            map(response => {
                return new VatRateTypeDto(response);
            })
        );
    }

    updateVatRate(learningResourceFee: VatRateDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/update`;
        return this.http.put<any>(url, learningResourceFee).pipe(
            map(response => {
                return new VatRateDto(response);
            })
        );
    }

    updateTypeVatRate(learningResourceFee: VatRateTypeDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/vat-rate/type/update`;
        return this.http.put<any>(url, learningResourceFee).pipe(
            map(response => {
                return new VatRateTypeDto(response);
            })
        );
    }
}